const titles = {
	start: 'Make a payment',
	confirmSavedPayment: 'Confirm payment details',
	confirmNewAuthNetPayment: 'Confirm payment details',
	confirmNewStripePayment: 'Confirm payment details',
} as const;

export type DialogMakePaymentStep = keyof typeof titles;

export default titles;
